import {jsonArrayMember, jsonMember, jsonObject} from "typedjson";

/**
 * Усовие фильтрации
 *
 */
@jsonObject
export class PitRequestCriteriaFilter {

  /** Наименование поля для фильтрации */
  @jsonMember({name: "field", constructor: String, emitDefaultValue: false, isRequired: false })
  private _field: string;

  /** Условие на значение. Допустимые операции: <, >, >=, <=, =, !=, BETWEEN, IN, CONTAIN  */
  @jsonMember({name: "condition", constructor: String, emitDefaultValue: false, isRequired: false })
  private _condition: string;

  /** Значение фильтрации для поля, приведенное к строковому типу */
  @jsonMember({name: "filterValue", constructor: String, emitDefaultValue: false, isRequired: false })
  private _filterValue: string;

  /** Массив значений фильтрации для поля, приведенных к строковому типу */
  @jsonArrayMember(String, {name: "filterValues", emitDefaultValue: false, isRequired: false})
  private _filterValues: string[] = [];

  /** Значение фильтрации для поля, приведенное к строковому типу */
  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false })
  value: string;

  /** Массив значений фильтрации для поля, приведенных к строковому типу */
  @jsonArrayMember(String, {emitDefaultValue: false, isRequired: false})
  values: string[] = [];


  get field(): string {
    return this._field;
  }

  set field(value: string) {
    this._field = value;
  }

  get condition(): string {
    return this._condition;
  }

  set condition(value: string) {
    this._condition = value;
  }

  get filterValue(): string {
    return this._filterValue;
  }

  set filterValue(value: string) {
    this._filterValue = value;
  }

  get filterValues(): string[] {
    return this._filterValues;
  }

  set filterValues(value: string[]) {
    this._filterValues = value;
  }

  constructor(fields?: Partial<PitRequestCriteriaFilter>) {
    if (fields)
      Object.assign(this, fields);
  }
}
